export enum RankQueryQueys {
  Primary = 'rank-status/',
  ByUser = 'rank-status/by-user',
}
